// Typedef Helpers


/**
 * Internal type definition of the unblu object.
 * @hidden
 */
export interface UnbluObject {
    api?: any,

    /**
     * internal unblu field
     * @hidden
     */
    APIKEY?: string,
    /**
     * internal unblu field
     * @hidden
     */
    SERVER?: string,
    /**
     * internal unblu field
     * @hidden
     */
    l?: string
}

/**
 * @hidden
 */
export class UnbluUtil {
    static async loadScript(uri: string, timeout: number): Promise<void> {
        const timeoutTime = timeout || 30000;
        const script = document.createElement('script');
        script.setAttribute('charset', 'UTF-8');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('async', 'true');
        script.setAttribute('timeout', timeoutTime.toString());
        script.src = uri;

        return new Promise<void>(function (resolve, reject) {
            let timeoutId: number;

            const cleanup = () => {
                // avoid mem leaks in IE.
                script.onerror = script.onload = null;
                window.clearTimeout(timeoutId);
            };

            const onError = (error: string | Event) => {
                cleanup();
                console.error('Failed to load script! Uri:', uri, 'Error:', error);
                reject(error);
            };

            script.onload = () => {
                cleanup();
                resolve();
            };
            script.onerror = onError;
            timeoutId = window.setTimeout(() => onError('Timeout'), timeoutTime);

            const head = document.getElementsByTagName('HEAD')[0];
            head.appendChild(script);
        });
    }

    static setNamedArea(namedArea: string): void {
        const metaTag = window.document.querySelector('meta[name="unblu:named-area"]') || window.document.createElement('meta');
        metaTag.setAttribute('name', 'unblu:named-area');
        metaTag.setAttribute('content', namedArea);
        if (!metaTag.parentElement) {
            window.document.head.appendChild(metaTag);
        }
    }

    static setLocale(locale: string): void {
        // unblu.l will be read in user-locale-util.js
        UnbluUtil.getUnbluObject().l = locale;
    }

    static isUnbluLoaded(): boolean {
        return UnbluUtil.getUnbluObject() && !!UnbluUtil.getUnbluObject().APIKEY;
    }

    static getUnbluObject(): UnbluObject {
        return window.unblu;
    }

    static createUnbluObject(): UnbluObject {
        return window.unblu = {};
    }

}